import Footer from "@/components/footer";
import type { ReactNode } from "react";
import Header from "../components/header";
import type { Data } from "../types/data";

interface Layout02Props {
	data: Data;
	children?: ReactNode;
}

export default function Layout02({ data, children }: Layout02Props) {
	return (
		<div className="min-h-screen bg-zinc-50">
			<Header data={data} />
			<main className="pt-20 md:pt-24">{children}</main>
			<Footer data={data} />
		</div>
	);
}
